import React, { useReducer } from 'react'
import logo from './logo.svg'
import './App.css'
import Header from "./header"
import Qboid from "./Qboid/qboid"
import Qboids from "./Qboid/qboids"
import Connection from "./Connection/connection"
import Connections from "./Connection/connections"
import Setup from "./Setup/setup"
import Setups from "./Setup/setups"
import Transactions from "./Transaction/transactions"
import Transaction from "./Transaction/transaction"
import Home from "./home"
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import { ProtectedRoute } from "./components/protectedRoute";

function App(props) {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/connections" element={<ProtectedRoute><Connections /></ProtectedRoute>} />
          <Route path="/connection/:id" element={<ProtectedRoute><Connection /></ProtectedRoute>} />
          <Route path="/connection" element={<ProtectedRoute><Connection /></ProtectedRoute>} />
          <Route path="/setups" element={<ProtectedRoute><Setups /></ProtectedRoute>} />
          <Route path="/setup/:id" element={<ProtectedRoute><Setup /></ProtectedRoute>} />
          <Route path="/setup" element={<ProtectedRoute><Setup /></ProtectedRoute>} />
          <Route path="/qboids" element={<ProtectedRoute><Qboids /></ProtectedRoute>} />
          <Route path="/qboid/:id" element={<ProtectedRoute><Qboid /></ProtectedRoute>} />
          <Route path="/qboid" element={<ProtectedRoute><Qboid /></ProtectedRoute>} />
          <Route path="/transactions" element={<ProtectedRoute><Transactions /></ProtectedRoute>} />
          <Route path="/transaction/:id" element={<ProtectedRoute><Transaction /></ProtectedRoute>} />
          <Route path="/" element={<Home />} />
        </Routes>
      </div >
    </Router>
  )
}

export default App